import React from 'react';
import OrganizationNeedsSetupV2 from 'pages/OrganizationPage/componentsOrganization/OrganizationNeedsSetupV2';

const TeamSetupPage: React.FC = () => {
    return <OrganizationNeedsSetupV2 />;
};

export default TeamSetupPage;
